import * as z from "zod/v4";
import {
  MarketingAgentAnalyticsInputSchema,
  MetricWithComparisonSchema,
} from "./common";

export const getMarketingAgentLlmCostMetrics = {
  name: "getMarketingAgentLlmCostMetrics" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.object({
    sentinelCost: MetricWithComparisonSchema,
    vanguardCost: MetricWithComparisonSchema,
    emailWriterCost: MetricWithComparisonSchema,
    smsWriterCost: MetricWithComparisonSchema,
    totalCost: MetricWithComparisonSchema,
  }),
};
